// test1322
(1322 && 0);
